var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"register-intro box fixed-width"},[(_vm.currentPage == 1)?_c('register-form'):_vm._e()],1),_c('login-hint')],1)}
var staticRenderFns = []

export { render, staticRenderFns }